import { render, staticRenderFns } from "./RedeemList.vue?vue&type=template&id=39c026ac&scoped=true&"
import script from "./RedeemList.vue?vue&type=script&lang=js&"
export * from "./RedeemList.vue?vue&type=script&lang=js&"
import style0 from "./RedeemList.vue?vue&type=style&index=0&id=39c026ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c026ac",
  null
  
)

export default component.exports